module.exports = __webpack_public_path__ + "static/bar-01-min-2a356123e0a3034016da9c031055e8b4.jpg";